"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Collapse = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Collapse component for the web
 */
var Collapse = /*#__PURE__*/function (_React$Component) {
  _inherits(Collapse, _React$Component);

  var _super = _createSuper(Collapse);

  function Collapse() {
    var _this;

    _classCallCheck(this, Collapse);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "wrapperModifyTimeout", void 0);

    _defineProperty(_assertThisInitialized(_this), "wrapperRef", null);

    _defineProperty(_assertThisInitialized(_this), "onTransitionEnd", function (ev) {
      if (!_this.wrapperRef) {
        return;
      } // when animating open, we set the wrapper's height to an explicit pixel
      // value. When the transition ends we want to set the height back to 'auto'
      // so that if the content of the wrapper changes it's height will change too


      if (ev.propertyName === "height") {
        _this.wrapperRef.style.height = _this.props.open ? "auto" : "0px";
      }
    });

    _defineProperty(_assertThisInitialized(_this), "firstRender", {
      open: _this.props.open
    });

    return _this;
  }

  _createClass(Collapse, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.wrapperRef) {
        return;
      }

      this.wrapperRef.addEventListener("transitionend", this.onTransitionEnd);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this2 = this;

      if (!this.wrapperRef) {
        return;
      }

      if (this.props.open && this.wrapperRef.style.height !== "auto") {
        // animate opening
        // measure goal height
        var prevHeight = this.wrapperRef.style.height || "0px";
        this.wrapperRef.style.height = "auto";
        var goalheight = this.wrapperRef.offsetHeight;
        this.wrapperRef.style.height = prevHeight; // wait for a tick before setting goal height to allow transition

        this.wrapperModifyTimeout = setTimeout(function () {
          _this2.wrapperRef.style.height = goalheight + "px";
        }, 10);
      } else if (!this.props.open && this.wrapperRef.style.height !== "0px") {
        // animate closing
        // set the wrapper's current height explicitly
        var currentHeight = this.wrapperRef.offsetHeight;
        this.wrapperRef.style.height = currentHeight + "px"; // wait for a tick before setting it to 0 to allow transition

        this.wrapperModifyTimeout = setTimeout(function () {
          _this2.wrapperRef.style.height = "0px";
        }, 10);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.wrapperRef.removeEventListener("transitionend", this.onTransitionEnd);
      clearTimeout(this.wrapperModifyTimeout);
    } // this is set until the first time `open` changes
    // then it becomes null. This helps us with SSR.

  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          children = _this$props.children,
          open = _this$props.open; // render explicit height before first change, so SSR works properly.
      // Thereafter we control the height property entirely in componentDidMount
      // (which doesn't get called during SSR)

      var heightProps = {};

      if (this.firstRender) {
        // render() might be called multiple times before the first time `open` changes
        if (this.firstRender.open !== open) {
          // `open` prop has changed for the first time
          // ditch explicit height and let `componentDidUpdate` take the wheel
          this.firstRender = null;
        } else {
          heightProps = {
            height: open ? "auto" : "0px"
          };
        }
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        ref: function ref(_ref) {
          return _this3.wrapperRef = _ref;
        },
        style: _objectSpread({
          transition: "height 0.3s ease",
          overflow: "hidden"
        }, heightProps)
      }, children);
    }
  }]);

  return Collapse;
}(_react.default.Component);

exports.Collapse = Collapse;
Collapse.displayName = "Collapse";
//# sourceMappingURL=Collapse.js.map